import { render } from "./NoAccess.vue?vue&type=template&id=63dd8fd4&scoped=true"
const script = {}

import "./NoAccess.vue?vue&type=style&index=0&id=63dd8fd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63dd8fd4"]])

export default __exports__